import React, { Component } from "react";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
        }
    }
    componentDidMount(){
    }
    
    goQuery2(){
        this.props.history.push({ pathname: "/home/info2", state: {} });
    }

    render()
    {
        let hrefStr = `${process.env.PUBLIC_URL}/instruction.pdf`
        return (
            <div data-component="info2">
                <div class="sg-info-view">
                <div className="sg-info-font" style={{marginTop:'0.3rem'}}>1. 使用该功能时，请确保已经在手机微信APP/支付宝APP/百度APP安装 “电子营业执照”小程序，或已安装了“电子营业执照”APP，并且领用电子营业执照。</div>
                    <div className="sg-info-font">2. 如果尚未领取电子营业执照，请企业法定代表人在微信APP/支付宝APP/百度APP上安装“电子营业执照”小程序，或安装“电子营业执照”APP后下载电子营业执照。</div>
                    <div className="sg-info-font">3. 小程序和APP的软件安装方式有以下五种：</div>
                    <div className="sg-info-font">(1) 在微信APP中输入“电子营业执照”搜索安装微信版“电子营业执照”小程序，或者用微信APP扫“微信电子营业执照二维码”安装微信版“电子营业执照”小程序。</div>
                    <div className="sg-info-font">(2) 在支付宝APP中输入“电子营业执照”搜索安装支付宝版“电子营业执照”小程序，或者用支付宝APP扫“支付宝电子营业执照二维码”安装支付宝版“电子营业执照”小程序。</div>
                    <div className="sg-info-font">(3) 在百度APP中输入“电子营业执照”搜索安装百度版“电子营业执照”小程序，或者用百度APP扫“百度电子营业执照二维码”安装百度版“电子营业执照”小程序。</div>
                    <div className="sd-spaceBetween">
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/business/weixinxiao.png')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/business/zhifubaoxiao.png')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/business/baiduxiao.png')} />
                        </div>
                    </div>
                    <div className="sg-info-font">(3) 安卓手机在手机自带的“应用市场”或“腾讯应用宝”中输入“电子营业执照”搜索安装APP，或者用手机浏览器扫“安卓版电子营业执照二维码”，安装安卓版“电子营业执照”APP。</div>
                    <div className="sg-info-font">(4) 苹果手机在App Store中输入“电子营业执照”搜索安装APP，或者使用相机扫“苹果版电子营业执照二维码”，安装苹果版“电子营业执照”APP。</div>
                    <div className="sd-spaceBetween">
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/business/androidApp.png')} />
                        </div>
                        <div className="sg-info-list">
                            <img className='sg-list-img' alt='#' src={require('../../img/business/iosApp.png')} />
                        </div>
                        <div className="sg-info-list">
                        </div>
                    </div>
                    <div className="sg-info-font">4. 法定代表人在“电子营业执照”小程序或APP领取手机版电子营业执照后，可自行或授权他人使用电子营业执照：</div>
                    <div className="sg-info-font">(1) 法定代表人可授权证照管理员对该电子营业执照进行日常的管理和使用。证照管理员可以在手机上安装“电子营业执照”小程序或APP，用小程序或APP中的“下载执照”，对证照管理员实名认证后，下载电子营业执照。</div>
                    <div className="sg-info-font">(2) 法定代表人或证照管理员可以授权指定办事人持电子营业执照办理相关的政务、商务、公共服务等业务。办事人可以在手机上安装“电子营业执照”小程序或APP，用小程序或APP中的“下载执照”，对办事人实名认证后，下载电子营业执照。</div>
                    
                    <div className="sg-info-font">5. <a className="sg-strong-font" rel="noopener noreferrer" href={hrefStr} target="_blank">电子营业执照用户使用手册下载</a></div>
                </div>
            </div>
        )
    }
}

export default Index
